<template>
  <vca-card></vca-card>
</template>
<script>
export default {
  name: "TourView",
  mounted() {
    window.location.href = process.env.VUE_APP_TOUR_URL;
  },
};
</script>
